import React from "react";
import { Autocomplete, Paper, SvgIcon, TextField, Tooltip, IconButton } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { TimelineCard } from "./TimelineCard";
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import { D } from "../include";
import ReactToPrint from "react-to-print";
import Icon from '@mui/material/Icon';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { DialogActions, InputLabel, Select, MenuItem, FormControl, CircularProgress } from "@mui/material";
import { BrowserUpdated, Summarize, List, Mail } from '@mui/icons-material';
import { saveAs } from 'file-saver'
import { TimelineCardTodosDocumentos } from "./TimelineCardTodosDocuments";
import { ModalSendEmailGroup } from "./ModalSendEmailGroup";
import moment from "moment";

const oicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const filterIt = (terms, arr) => {
  if ("" === terms || terms.length < 3) return arr;
  var words = terms.match(/"[^"]+"|\w+/g);

  words = words.map(val => val.replace(/"/g, ""));
  return arr.filter((a) => {
    const v = Object.values(a);
    const f = JSON.stringify(v).toLowerCase();

    return words.every(val => f.includes(val));
  });
};

const orderKeysMail = ['fornecedor', 'tipoDocumento', 'data', 'name', 'pendencia', 'pedidoReparo', 'aprovacao', 'documento']


const style = {
  overflow: 'hidden',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '70vw',
  minWidth: '50vw',
  minHeight: '10vh',
  maxHeight: '60vh',
  bgcolor: 'background.paper',
  borderRadius: '1rem',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  position: "absolute",
  isLoading: false
};

export class TimelineClass extends React.PureComponent {
  constructor(props) {
    super(props)
    this.node = React.createRef()
    this.state = {
      factFilters: [],
      timelineBody: [],
      currentPage: 1,
      postsPerPage: 10,
      card: false,
      closeCard: true,
      timelineResponse: [],
      fatos: [],
      parseInit: 0,
      ocorrenciasModal: false,
      factFiltersModal: [],
      ocorrencias1Modal: false,
      fullDocumentsModal: false,
      showModalSendEmail: false,
      count: 0,
      isLoadingPdf: false,
      debounceTextSearch: '',
      selectedOccurences: {},
    };
    this.onCloseModalMail = this.onCloseModalMail.bind(this)
    this.onShowModalMail = this.onShowModalMail.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangePageSize = this.handleChangePageSize.bind(this)
    this.handleDebouncedText = debounce(this.handleDebouncedText.bind(this), 500)
  };

  OnClickCard = e => {
    this.setState({ card: true });
    this.setState({ doc_id: e })
  };

  OnCloseCard = () => {
    this.setState({ card: false })
  };

  OnCloseModal = () => {
    this.setState({ ocorrenciasModal: false })
  };

  OnCloseModal1 = () => {
    this.setState({ ocorrencias1Modal: false })
  };

  getDocId = e => {
    this.setState({ doc_id: e })
  };

  getTimelineBody = async (e) => {
    if (e.length === 0) {
      this.setState({
        timelineBody: [],
        timelineResponse: [],
        count: 0,
        debounceTextSearch: '',
      })
      this.props.onClearText()
      return;
    }
    if (!e) return;
    e.map(element => {
      this.state.fatos.map(objs => {
        if (objs.fato_id === element.fato_id) {
          if (objs.ocorrencias !== element.ocorrencias) objs.ocorrencias = element.ocorrencias
        }
      });
      if (!(element.fato_id in this.state.fatos)) this.state.fatos.push(element)
    });

    const newFatos = this.state.fatos.filter((object, index) => {
      return index === this.state.fatos.findIndex(value => object.fato_id === value.fato_id)
    }).filter(item => item.ocorrencias.length !== 0);
    this.setState({ fatos: newFatos });
    if (newFatos.length === 0) {
      this.setState({
        timelineBody: [],
        timelineResponse: [],
        count: 0,
        debounceTextSearch: '',
      })
      this.props.onClearText()
      return;
    }
    this.setState({ isLoading: true })
    const sanitizedNewFatos = newFatos.map(item => ({ ...item, ocorrencias: item.ocorrencias.filter(value => value !== 'Todos') }))
    const queryParams = {
      filters: JSON.stringify(sanitizedNewFatos),
      textFilter: this.state.debounceTextSearch,
      page: this.state.currentPage,
      pageSize: this.state.postsPerPage,
      dataInicio: this.props.dataInicio,
      dataFim: this.props.dataFim,
      orderBy: JSON.stringify(['Data Aproximada', 'desc']),
      showUnread: this.props.showUnread
    }
    const queryStringParams = new URLSearchParams(queryParams)
    const { data, count } = await this.props.api.get(`timeline?${queryStringParams.toString()}`)
    const body = [...data, ...this.props.docsPending].map(e => ({
      id: e.id,
      doc_id: e.document_id,
      date: e.created_at,
      dtaprox: e.dtaprox,
      data: e.dtaprox,
      fatos: e.fatos_do_documento,
      status: e.status,
    }));
    let value = [];

    for (let i = 0; i < body.length; i++) {
      value.push(body[i].dtaprox);
      value[i] = value[i] ? value[i].split("/").reverse().join("/") : body[i].created_at;
      value[i] = Date.parse(value[i]);
      body[i].dtaprox = value[i];

      if (body[i].status === 'processado') {
        body[i].status_icon = 'check_circle'
      } else if (body[i].status === 'não processado') {
        body[i].status_icon = 'sync'
      } else if (body[i].status === 'em processamento') {
        body[i].status_icon = 'sync_disabled'
      }
    };

    body.forEach(value => {
      value.fatos.forEach(item => {
        if (item.qualificator === 'Nome de Embarcação') {
          value.name = item.valor
        }
        if (item.qualificator === 'Tipo de Documento') {
          value.tipoDocumento = item.valor
        }
        if (item.qualificator === 'Fornecedor') {
          value.fornecedor = item.valor
        }
      });
    });

    this.setState({ timelineBody: [...body], count: +count, isLoading: false })
    this.setState({ timelineResponse: [...body] })

    if (body.length === 0) {
      this.setState({ currentPage: 1 })
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.factId !== prevProps.factId) {
      this.props.api.get(`Timeline/Fatos/${JSON.stringify(this.props.factId)}`).then(r => {
        this.setState({ factFilters: r })
      });

      const newFatos = this.state.fatos.filter((object, index) => {
        return this.props.factId.some(continuesId => object.fato_id === continuesId)
      });

      this.setState({ fatos: newFatos },
        () => {
          this.getTimelineBody(this.state.fatos)
        })
    } else if (this.props.factIdOpen !== prevProps.factIdOpen) {
      this.props.api.get(`Timeline/Fatos/${JSON.stringify(this.props.factIdOpen)}`).then(r => {
        this.setState({ factFiltersModal: r });
        this.setState({ ocorrencias1Modal: true })
      });
    } else if (this.state.count !== prevState.count) {
      this.setState({ currentPage: 1 })
    }
    else if (this.props.dataInicio !== prevProps.dataInicio) {
      this.getTimelineBody(this.state.fatos)
    } else if (this.props.dataFim !== prevProps.dataFim) {
      this.getTimelineBody(this.state.fatos)
    } else if (this.props.search !== prevProps.search) {
      this.handleDebouncedText(this.props.search)
    }
    if (this.props.selectTimelineParameters !== prevProps.selectTimelineParameters) {
      let selectedOccurences = {}
      this.props.selectTimelineParameters?.forEach(item => {
        selectedOccurences[item.fato_id] = item.ocorrencias
      })
      console.log(selectedOccurences)
      this.setState({ selectedOccurences: selectedOccurences })
      this.getTimelineBody(this.props.selectTimelineParameters)
    }
    if (this.state.fatos !== prevState.fatos) {
      const selectFactsName = this.props.selectFactsName ?? [];
      const timelineParameters = this.state.fatos ?? [];
      this.props.api.post(`/users/selectParametersTimeline?user_id=${this.props.user.id}&selectFactName=${JSON.stringify(selectFactsName)}&timelineParameters=${JSON.stringify(timelineParameters)}`)
    }
    if (prevProps.docsPending.length === 0 && this.props.docsPending.length !== 0) {
      this.getTimelineBody([])
    }
    if (this.state.currentPage !== prevState.currentPage) {
      this.getTimelineBody(this.state.fatos)
    }
    if (this.state.postsPerPage !== prevState.postsPerPage) {
      this.getTimelineBody(this.state.fatos)
    }
    if (this.state.debounceTextSearch !== prevState.debounceTextSearch) {
      this.getTimelineBody(this.state.fatos)
    }
    if (this.props.showUnread !== prevProps.showUnread) {
      this.getTimelineBody(this.state.fatos)
    }
  }

  handleDebouncedText(value) {
    this.setState({ debounceTextSearch: value });
  }

  findMatchingValues(fato_id) {
    const chooseFato = this.state.fatos.find(chooseFatoId => chooseFatoId.fato_id === fato_id);
    if (chooseFato !== undefined) {
      const facts = this.state.factFilters.length ? this.state.factFilters : this.state.factFiltersModal
      const fact = facts.find(item => item.fato_id === fato_id)
      // console.log(fact, chooseFato.ocorrencias)
      if (chooseFato.ocorrencias.length === fact.quantificador_maquina.length) {
        return ['Todos', ...chooseFato.ocorrencias]
      }


      return chooseFato.ocorrencias
    };
  };

  handleMergePDFsAndDownload = () => {
    if (this.state.timelineBody.length === 0)
      this.props.alert('Operação com Linha do Tempo Vazia')
    else {
      this.setState({ isLoadingPdf: true })
      const newFatos = this.state.fatos.filter((object, index) => {
        return index === this.state.fatos.findIndex(value => object.fato_id === value.fato_id)
      }).filter(item => item.ocorrencias.length !== 0);
      const queryParams = {
        filters: JSON.stringify(newFatos),
        textFilter: this.state.debounceTextSearch,
        dataInicio: this.props.dataInicio,
        dataFim: this.props.dataFim,
        showUnread: this.props.showUnread,
      }
      const queryStringParams = new URLSearchParams(queryParams)
      this.props.api.get(`/timeline/export-pdf?${queryStringParams.toString()}`, { responseType: 'arraybuffer' }).then(async response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        saveAs(blob, "MergedDocs.pdf")
      }).finally(() => {
        this.setState({ isLoadingPdf: false })
      })
    }
  };

  onCloseFullDocumentModal = () => {
    this.setState({ fullDocumentsModal: false })
  }

  onShowFullDocumentModal = () => {
    this.setState({ fullDocumentsModal: true })
  }

  onCloseModalMail() {
    this.setState({ showModalSendEmail: false })
  }

  onShowModalMail() {
    this.setState({ showModalSendEmail: true })
  }

  handleChangePageSize(event) {
    this.setState({ postsPerPage: event.target.value })
  };

  handleChangePage(e, p) {
    this.setState({ currentPage: p });
  }

  render() {
    const totalPages = Math.ceil(this.state.count / this.state.postsPerPage)
    return (
      <>
        {this.state.ocorrencias1Modal &&
          <Modal open={this.state.ocorrencias1Modal}
            onClose={this.OnCloseModal1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box style={style} sx={{ bgcolor: 'white' }}>
              <header style={{ paddingBottom: "6px", borderBottom: "1px solid gray", flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <h2 style={{ padding: 0, margin: 0, color: "#3f3f3f" }}>Ocorrências Observadas</h2>
                </div>
                <div style={{ textAlign: 'end', padding: 0, margin: 0 }}>
                  <CloseIcon onClick={() => this.OnCloseModal1()} sx={{
                    ":hover": {
                      color: 'grey', backgrounColor: 'white'
                    }
                  }} />
                </div>
              </header>
              <div style={{ display: 'flex', flexDirection: "column", position: 'relative', height: 'calc(100% - 72px)' }}>

                {
                  this.state.factFiltersModal &&
                  this.state.factFiltersModal.map(element => (
                    <Autocomplete
                      key={element.fato_id}
                      multiple={true}
                      id="checkboxes-tags-demo"
                      // options={element.quantificador_maquina}
                      options={mergeArrayByPosition(element.quantificador_maquina, element.quantificador_homem)}
                      // value={this.findMatchingValues(element.fato_id) || []}
                      value={this.state.selectedOccurences[element.fato_id] || []}
                      getOptionLabel={(options) => options || ''}
                      // isOptionEqualToValue={(option, value) =>
                      //   option === value
                      // }
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={oicon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected} />
                          {option}
                        </li>
                      )}
                      style={{ width: "100%", paddingBottom: '10px', paddingTop: '15px', marginTop: '4px' }}
                      renderInput={(params) => (
                        <TextField {...params} label={element.qualificator} placeholder="" />
                      )}
                      onChange={(e, value) => {
                        const allOption = 'Todos'
                        const hasAll = value.includes(allOption)
                        const ocorrenciasAll = mergeArrayByPosition(element.quantificador_maquina, element.quantificador_homem)
                        const allExceptAllOption = ocorrenciasAll.slice(1)
                        if (hasAll && !this.state.selectedOccurences[element.fato_id]?.includes(allOption)) {
                          this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: ocorrenciasAll } })
                          this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: ocorrenciasAll }])
                        } else if (!hasAll && this.state.selectedOccurences[element.fato_id]?.includes(allOption)) {
                          this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: [] } })
                          this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: [] }])
                        } else if (value.length === allExceptAllOption.length &&  allExceptAllOption.every(opt => value.includes(opt))) {
                          this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: ocorrenciasAll } })
                          this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: ocorrenciasAll }])
                        } else {
                          const newValue = value.filter(item => item !== 'Todos')
                          this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: newValue } })
                          this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: newValue }])
                        }
                      }} />
                  ))
                }
              </div>
              <DialogActions>
                <Button style={{ width: '100px' }} variant="outlined" color="primary" onClick={() => this.OnCloseModal1()}>OK</Button>
              </DialogActions>
            </Box>
          </Modal>
        }
        <Stack display='' sx={{ "@media print": { displayPrint: "none" }, }}>
          <div>
            <Button sx={{ marginRight: '10px' }} variant='outlined' onClick={() => this.setState({ ocorrenciasModal: true })}>Ocorrências escolhidas</Button>
            {this.state.ocorrenciasModal &&
              <Modal open={this.state.ocorrenciasModal}
                onClose={this.OnCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box style={style} sx={{ bgcolor: 'white' }}>
                  <header style={{ paddingBottom: "6px", borderBottom: "1px solid gray", flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <h2 style={{ padding: 0, margin: 0, color: "#3f3f3f" }}>Ocorrências Observadas</h2>
                    </div>
                    <div style={{ textAlign: 'end', padding: 0, margin: 0 }}>
                      <CloseIcon onClick={() => this.OnCloseModal()} sx={{
                        ":hover": {
                          color: 'grey', backgrounColor: 'white'
                        }
                      }} />
                    </div>
                  </header>
                  <div style={{ display: 'flex', flexDirection: "column", position: 'relative', overflowY: 'scroll', height: 'calc(100% - 72px)' }}>

                    {
                      this.state.factFilters &&
                      this.state.factFilters.map(element => (
                        <Autocomplete
                          key={element.fato_id}
                          multiple={true}
                          id="checkboxes-tags-demo"
                          // options={element.quantificador_maquina.some(item => !!item) ? element.quantificador_maquina : element.quantificador_homem}
                          options={mergeArrayByPosition(element.quantificador_maquina, element.quantificador_homem)}
                          // value={this.findMatchingValues(element.fato_id) || []}
                          value={this.state.selectedOccurences[element.fato_id] || []}
                          getOptionLabel={(options) => options || ''}
                          // isOptionEqualToValue={(option, value) =>
                          //   option === value
                          // }
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={oicon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected} />
                              {option}
                            </li>
                          )}
                          style={{ width: "100%", paddingBottom: '10px', paddingTop: '15px', marginTop: '4px' }}
                          renderInput={(params) => (
                            <TextField {...params} label={element.qualificator} placeholder="" />
                          )}
                          onChange={(e, value) => {
                            const allOption = 'Todos'
                            const hasAll = value.includes(allOption)
                            const ocorrenciasAll = mergeArrayByPosition(element.quantificador_maquina, element.quantificador_homem)
                            const allExceptAllOption = ocorrenciasAll.slice(1)
                            
                            if (hasAll && !this.state.selectedOccurences[element.fato_id]?.includes(allOption)) {
                              this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: ocorrenciasAll } })
                              this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: ocorrenciasAll }])
                            } else if (!hasAll && this.state.selectedOccurences[element.fato_id]?.includes(allOption)) {
                              this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: [] } })
                              this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: [] }])
                            } else if (value.length === allExceptAllOption.length &&  allExceptAllOption.every(opt => value.includes(opt))) {
                              this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: ocorrenciasAll } })
                              this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: ocorrenciasAll }])
                            } else {
                              const newValue = value.filter(item => item !== 'Todos')
                              this.setState({ selectedOccurences: { ...this.state.selectedOccurences, [element.fato_id]: newValue } })
                              this.getTimelineBody([{ fato_id: element.fato_id, ocorrencias: newValue }])
                            }
                          }} />
                      ))
                    }
                  </div>
                  <DialogActions>
                    <Button style={{ width: '100px' }} variant="outlined" color="primary" onClick={() => this.OnCloseModal()}>OK</Button>
                  </DialogActions>
                </Box>
              </Modal>
            }
          </div>
        </Stack>
        <div style={{ position: 'relative' }}>
          <div style={{ "@media print": { display: "block" } }} >
            <ReactToPrint trigger={() => <Tooltip title="Imprimir Linha do Tempo" arrow><IconButton><LocalPrintshopOutlinedIcon /></IconButton></Tooltip>}
              content={() => this.componentRef}
            >
            </ReactToPrint>
            <Tooltip title='Exportar PDF' arrow>
              <IconButton sx={{ marginLeft: '12px' }} onClick={() => this.handleMergePDFsAndDownload()} loading={this.state.isLoadingPdf}>
                { this.state.isLoadingPdf ? <CircularProgress size={20} /> : <BrowserUpdated /> }
              </IconButton>
            </Tooltip>
            <Tooltip title='Enviar por email' arrow>
              <IconButton sx={{ marginLeft: '12px' }} onClick={() => this.onShowModalMail()}>
                <Mail />
              </IconButton>
            </Tooltip>

            {
              this.state.isLoading
                ? <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}><CircularProgress /></div>
                : <div ref={el => (this.componentRef = el)} style={{ paddingBottom: 10 }}>
                  <Timeline position="alternate">
                    {this.state.timelineBody.length !== 0 &&
                      <TimelineItem className="no-print" >
                        <TimelineSeparator>
                          <TimelineDot sx={{ bgcolor: 'primary.main' }} >
                            <SvgIcon component={List} />
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent style={{ width: "40%" }}>
                          <D>
                            <Button onClick={() => this.onShowFullDocumentModal()}>
                              <Paper elevation={3} sx={{
                                maxWidth: '400px', maxHeigh: '420px', minHeight: '70px',
                              }} >
                                <Stack>
                                  <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', color: 'blue', padding: 20, alignItems: 'center' }}>
                                    <span>Lista de documentos</span>
                                  </div>
                                </Stack>
                              </Paper>
                            </Button>
                          </D>
                        </TimelineContent>
                      </TimelineItem>
                    }
                    {
                      this.state.timelineBody.map(element =>
                        <TimelineItem key={element.id}>
                          <TimelineSeparator>
                            <TimelineDot sx={{ bgcolor: 'primary.main' }} >
                              <SvgIcon component={Summarize} />
                            </TimelineDot>
                            <TimelineConnector />
                          </TimelineSeparator>
                          <TimelineContent style={{ width: "40%", }}>
                            <D>
                              <Button onClick={() => { this.OnClickCard(element.doc_id) }}>
                                <Paper elevation={3} sx={{
                                  maxWidth: '400px', maxHeigh: '420px', minHeight: '70px',
                                }} >
                                  <Stack>
                                    <div style={{ display: 'flex' }}>
                                      <Tooltip title={element.status} arrow>

                                        <Icon style={{ color: '#aaa' }}>{element.status_icon}</Icon>
                                      </Tooltip>
                                    </div>
                                    { element && (
                                      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flexWrap: 'wrap', color: 'blue' }}>
                                        <span> {element.name}</span>
                                        <span>{element.tipoDocumento}</span>
                                        <span>{element.fornecedor}</span>
                                      </div>
                                    )}

                                    <Stack direction='column' spacing={1} sx={{ display: 'flex' }}>
                                      <span style={{ textAlign: 'center' }}>
                                        {moment(element.data).format('DD/MM/YYYY')}
                                      </span>
                                      <div style={{ display: 'flex', justifyContent: 'center', padding: '5px', flexWrap: 'wrap', gap: "5px", color: '#aaa' }}>
                                        {element &&
                                          element.fatos.map(fato => {
                                            if (fato.icon_name) {
                                              return (
                                                <Tooltip key={fato.fato_id} title={fato.qualificator} arrow>
                                                  <Icon style={{ color: '#aaa' }}>{fato.icon_name}</Icon>
                                                </Tooltip>
                                              )
                                            }
                                            if (fato.qualificator === 'Aprovação') {
                                              if (!fato.valor) {
                                                return <></>
                                              }
                                              return (
                                                <Tooltip key={fato.fato_id} title={fato.qualificator} arrow>
                                                  <Icon
                                                    style={{ color: '#aaa' }}
                                                  >
                                                    {fato.valor?.toLowerCase() === 'aprovado' ? 'thumb_up' : 'thumb_down'}
                                                  </Icon>
                                                </Tooltip>
                                              )
                                            }
                                            return <></>
                                          })}
                                      </div>
                                    </Stack>
                                  </Stack>
                                </Paper>
                              </Button>
                            </D>
                          </TimelineContent>
                        </TimelineItem>
                      )
                    }
                  </Timeline>
                </div>}
          </div>
          {/* { this.state.timelineBody?.length !== 0 && ( */}
              <Box sx={{
                display: 'flex',
                justifyContent: 'end',
                marginRight: '15px',
                marginTop: '5px',
                position: 'fixed',
                bottom: 20,
                right: 0,
                backgroundColor: 'white'
              }}>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label" >Documentos</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={this.state.postsPerPage}
                    label="Documentos"
                    onChange={this.handleChangePageSize}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  count={totalPages}
                  size="large"
                  page={this.state.currentPage}
                  variant="outlined"
                  shape="rounded"
                  onChange={this.handleChangePage}
                  sx={{ paddingTop: '8px' }}
                />
              </Box>
            {/* )
          } */}
        </div>
        {
          this.state.card &&
          <>
            <TimelineCard doc_id={this.state.doc_id} api={this.props.api}
              stateCard={this.state.card} onCloseCard={this.OnCloseCard}
            />
          </>
        }
        {
          this.state.fullDocumentsModal && <TimelineCardTodosDocumentos
            api={this.props.api}
            showModal={this.state.fullDocumentsModal}
            onCloseCard={this.onCloseFullDocumentModal}
            data={this.state.timelineBody}
            onSelectRow={this.OnClickCard}
            dataInicio={this.props.dataInicio}
            dataFim={this.props.dataFim}
            fatos={this.state.fatos}
            textFilter={this.state.debounceTextSearch}
            showUnread={this.props.showUnread}
          />
        }
        {this.state.showModalSendEmail && <ModalSendEmailGroup
          api={this.props.api}
          show={this.state.showModalSendEmail}
          onClose={() => this.onCloseModalMail()}
          data={this.state.timelineBody}
          type="list-documents"
          functionFormatData={formatDataToReportMail}
          orderKeys={orderKeysMail}
        />
        }
      </>)
  }
}

function formatDataToReportMail(data) {
  console.log(data)
  const formattedData = data.reduce((acc, curr) => {
    const temp = {
      doc_id: curr.doc_id,
    }
    let pendenciaFalha = ''
    let pedidoReparoFato = ''
    curr.fatos.forEach(item => {
      if (item.qualificator === 'Nome de Embarcação') {
        temp.name = item.valor
      }
      if (item.qualificator === 'Tipo de Documento') {
        temp.tipoDocumento = item.valor
      }
      if (item.qualificator === 'Fornecedor') {
        temp.fornecedor = item.valor
      }
      if (item.qualificator === 'Aprovação') {
        temp.aprovacao = item.valor
      }
      if (item.qualificator === 'Causa da Falha') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Componentes com ponto quente' && item.valor !== '0') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Teste de Alarme e Falha IN') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Teste de Alarme e Falha NOK') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Existem Pendências') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Equipamento Pronto para Uso' && item.valor === 'NÃO') {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Status de Análise' && ['ALERTA', 'ATENÇÃO'].includes(item.valor)) {
        pendenciaFalha += `${item.qualificator} : ${item.valor}|`
      }
      if (item.qualificator === 'Pedido de Reparo') {
        pedidoReparoFato = item.valor
      }
    })
    temp.pedidoReparo = curr.pedido_reparo || pedidoReparoFato
    const { origin } = window.location
    temp.documento = `${origin}/viewer.html?p=${curr.doc_id}`
    temp.pendencia = pendenciaFalha
    temp.data = curr.data
    acc.push(temp)
    return acc
  }, [])

  return formattedData
}
// Mexer aqui, colocar um filter para tirar os em branco
function mergeArrayByPosition(arr1, arr2) {
  const result = [];
  const maxLength = Math.max(arr1.length, arr2.length);

  for (let i = 0; i < maxLength; i++) {
    if (arr1[i]) result.push(arr1[i]);
    if (arr2[i]) result.push(arr2[i]);
  }

  // const uniqueResult = [...new Set(result)];
  const uniqueResult = ['Todos', ...new Set(result)];
  return uniqueResult;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
